import { z } from "zod";

/**
 * The router state an Explore feed hands the article it opens: the feed's own
 * search (its filter: For You, a topic, a room chip). The desktop article page
 * reads it to name where the reader came from in its breadcrumb, so a room
 * chip picked in Explore reads "Explore / <room>", not "Rooms / <room>". A
 * cold entry (a shared link, a reload on Safari) carries none.
 *
 * `exploreList` says the feed also put its articles in the swipe cache: only
 * then does the article's pager walk that cache, not a list another surface
 * left there.
 */
export const exploreOriginStateSchema = z.object({
  exploreSearch: z.string().nullable().default(null),
  exploreList: z.boolean().default(false),
});

export function exploreOriginState(
  search: string,
  list: boolean
): z.input<typeof exploreOriginStateSchema> {
  return { exploreSearch: search, exploreList: list };
}
